import React, { Component } from "react";
import { Table } from "antd";
import Header from '../../Common/Component/Header';
import Sidebar from '../../Common/Component/Sidebar';
import DataTable from '../ReportList/Component/Datatable';
import moment from "moment-timezone";
import { formatToCurrency } from "../../../Tools/formatToCurrency";

class ViewBreakdown extends Component {
	state = {
	  owned_territory_details: [],
	  unowned_territory_details: [],
	  territory: {},
	  territory_sales: 0,
	  total_sales: 0,
	  end_date: moment().endOf('month'),
	  start_date: moment().startOf('month'),
	}

	componentDidMount = () => {
	  const record = this.props.location.state.query.record;
	  const start_date = this.props.location.state.query.start_date;
	  const end_date =  this.props.location.state.query.end_date;
	  let territory_name;

	  if(record.territory === "unowned" || record.territory === "Unowned")
	  {
	    territory_name ="Unowned";
	  }
	  else if(record.territory === "all" || record.territory === "All")
	  {
	    territory_name ="All";
	  }
	  else
	  {
	    territory_name = record.uuid;
	  }

	  this.setState({
	    territory: record, 
	    start_date, 
	    end_date, 
	    loader: true
	  });

	  this.props.getRoyaltyReportForViewBreakDown({
	    territory: territory_name,
	    field_office_uuids: record.franchise.uuid,
	    start_date,
	    end_date
	  });
	}

	UNSAFE_componentWillReceiveProps = (props) => {
	  if(props?.RoyaltyBreakDown && Object.keys(props?.RoyaltyBreakDown?.data).length > 0 &&
			props?.RoyaltyBreakDown?.data !== this.props?.RoyaltyBreakDown?.data){

	    this.setState({
	      loader: false,
	      territory_data: props?.RoyaltyBreakDown?.data[0],
	      territory_details: props?.RoyaltyBreakDown?.data[0]?.territory_data,
	      territory_sales: props?.RoyaltyBreakDown?.data[0]?.territory_data[0]?.totalsales,
	      total_sales: props?.RoyaltyBreakDown?.data[0]?.territory_all_data?.owned?.territory_data[0]?.total_sales + props?.RoyaltyBreakDown?.data[0]?.territory_all_data?.unowned?.territory_data[0]?.total_sales
	    });
	  }
	}

	renderHeader = () => {
	  const { territory, territory_sales, total_sales } = this.state;

	  return <div 
	    className="row"
	    style={{width: "99%", display: "flex", margin: "30px 0 0 15px"}}
	  >
	    <div
	      style={{
	        backgroundColor: "white",
	        flexGrow: "1",
	        padding: "30px",
	        flexDirection: "column",
	        border: "solid 1px #f4f7f9"
	      }}>
	      <span style={{display: "flex", color: "#5b5a5a", fontWeight: "bold"}}>Franchise</span>
	      <span style={{display: "flex", marginTop: "10px", fontWeight: "bold"}}>{territory?.franchise?.name}</span>
	    </div>
	    <div
	      className="row"
	      style={{
	        backgroundColor: "white",
	        flexGrow: "2",
	        padding: "30px",
	        flexDirection: "row",
	        border: "solid 1px #f4f7f9"
	      }}>
	      <div style={{display: "flex", flexDirection: "column", margin: "0 30px"}}>
	        <span
	          style={{
	            display: "flex",
	            color: "#5b5a5a",
	            fontWeight: "bold"
	          }}>Territory</span>
	        <span
	          style={{
	            display: "flex",
	            marginTop: "10px",
	            fontWeight: "bold",
	            color: "#5c5c5c"
	          }}>{territory.territory === "unowned" ? territory.territory.charAt(0).toUpperCase() + territory.territory.slice(1) : territory.territory}</span>
	      </div>
	      <div style={{display: "flex", flexDirection: "column", margin: "0 30px"}}>
	        <span
	          style={{
	            display: "flex",
	            color: "#5b5a5a",
	            fontWeight: "bold"
	          }}>Owner</span>
	        <span style={{display: "flex",
	          marginTop: "10px",
	          fontWeight: "bold",
	          color: "#5c5c5c"
	        }}>{territory.owner}</span>
	      </div>
	      {
	        territory.territory === "All" ? null :
	          <div
	            style={{
	              display: "flex",
	              flexDirection: "column",
	              margin: "0 30px"
	            }}>
	            <span
	              style={{display: "flex",
	                color: "#5b5a5a",
	                fontWeight: "bold"
	              }}>Territory Sales</span>
	            <span
	              style={{
	                display: "flex",
	                marginTop: "10px",
	                fontWeight: "bold",
	                color: "#5c5c5c"
	              }}>$ {formatToCurrency(territory_sales)}</span>
	          </div>
	      }
	      <div style={{display: "flex",
	        flexDirection: "column",
	        margin: "0 30px"}}>
	        <span style={{display: "flex",
	          color: "#5b5a5a",
	          fontWeight: "bold"}}>Total Sales</span>
	        <span style={{display: "flex",
	          marginTop: "10px",
	          fontWeight: "bold",
	          color: "#5c5c5c"}}>$ {formatToCurrency(total_sales)}</span>
	      </div>
	    </div>
	  </div>
	}

	renderTerritoryTables = () => {
	  const {territory_details, territory} = this.state;

	  return territory_details?.map(territoryItem => {
	    let show_table_title = false;

	    if(territory_details.length >= 1) 
	    {
	      if(territoryItem.territory !== (territory.territory.charAt(0).toUpperCase() + territory.territory.slice(1)))
	      {
	        show_table_title = true;
	      }
	      else if(territoryItem.territory === "Unowned")
	      {
	        show_table_title = true;
	      }
	    }

	    return <div 
	      key={territoryItem.territory}
	      style={{
	        width: "99.5%",
	        display: "flex",
	        margin: "0px 30px 0 15px",
	        backgroundColor: "white",
	        padding: "20px",
	        flexDirection: "column"
	      }}>
	      {
	        show_table_title ? 
	          <h3 style={{color: "#5b5a5a"}}>{territoryItem.territory}</h3> : null
	      }
	      <Table
	        rowKey={(record) => record.id}
	        className="table hscroll"
	        dataSource={territoryItem.zipcode}
	        pagination={false}
	        columns={DataTable.RoyaltyReportBreakDownDetails(this)}
	      /> 
	    </div>
	  });
	}

	generateExport = () => {
	  const {
	    territory,
	    total_sales,
	    territory_sales,
	    territory_details,
	  } = this.state;

	  let csvContent = [
	    ['Franchise', 'Territory', 'Owner', 'Territory Sales', 'Total Sales'], 
	    [`\n${territory?.franchise?.name}`, territory.territory, territory.owner, parseFloat(territory_sales).toFixed(2), parseFloat(total_sales).toFixed(2)],
	    ['\n\nZip Code', 'Sales']
	  ];
		
	  if(territory_details?.length > 0)
	  {
	    territory_details.forEach(item => {
	      csvContent.push(`\n${item.territory}`);
				
	      item.zipcode.forEach(zipcode => {
	        csvContent.push([`\n${zipcode.zipcode}`, parseFloat(zipcode.total_sales_by_zipcode).toFixed(2)]);
	      });
	    });
	  }

	  var blob = new Blob(csvContent, { type: "text/CSV" });
	  var link = document.createElement("a");
	  link.href = window.URL.createObjectURL(blob);
	  link.download = `Royalty Report-${territory?.franchise?.name} Breakdown.csv`;
	  document.body.appendChild(link);
	  link.click();
	  document.body.removeChild(link);
	}

	renderView = () => {
	  return <div style={{margin: "15px"}}>
	    <li onClick={() => this.props.history.push("/reports/report", {query: {id: "royalty-report"}})}>
	      <span className="pointer">
	        <i className="las la-angle-left"></i> 
					Back to Royalty Report
	      </span>
	    </li>
	    <div className="row" style={{display: "flex", justifyContent: "space-between"}}>
	      <h2 style={{marginTop: "20px", fontSize: "28px", marginLeft: "20px"}}>Royalty Report Breakdown</h2>
	      <button
	        className="btn
					btn-warning"
	        style={{"alignSelf": "baseline", "margin": "0px 10px"}}
	        onClick={this.generateExport}
	      >
					Export
	      </button>
	    </div>
	    {this.renderHeader()}
	    {this.renderTerritoryTables()}
	  </div>
	}

	render () {
	  return <div id="wrapper">
	    <div className="content-area">
	      {/* Header */}
	      <Header />
	      {/* Sidebar */}
	      <Sidebar history={this.props.history} />

	      <div className="dashcontainer">
	        <div className="">
	          {this.renderView()}
	        </div>
	      </div>
	    </div>
	  </div>
	}
}

export default ViewBreakdown;